'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.schema = undefined;

var _Joi$string, _Joi$string2;

var _joi = require('joi');

var _joi2 = _interopRequireDefault(_joi);

var _helpers = require('./helpers');

var _constant = require('./constant');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var valid = {
  order: ['allunique', 'favnovelcnt', 'reviewcnt', 'hyoka', 'hyokaasc', 'impressioncnt', 'hyokacnt', 'hyokacntasc', 'weekly', 'lengthdesc', 'lengthasc', 'ncodedesc', 'old'],
  of: ['-', 't', 'n', 'u', 'w', 's', 'bg', 'g', 'k', 'gf', 'gl', 'nt', 'e', 'ga', 'l', 'ti', 'i', 'ir', 'ibl', 'igl', 'izk', 'its', 'iti', 'p', 'gp', 'f', 'r', 'a', 'ah', 'sa', 'ka', 'nu', 'ua'],
  biggenre: [1, 2, 3, 4, 99, 98],
  genre: [101, 102, 201, 202, 301, 302, 303, 304, 305, 306, 307, 401, 402, 403, 404, 9901, 9902, 9903, 9904, 9999, 9801],
  type: ['t', 'r', 'er', 're', 'ter'],
  buntai: [1, 2, 4, 6],
  lastup: ['thisweek', 'lastweek', 'sevenday', 'thismonth', 'lastmonth', '(\\d+)?-?(\\d+)?']
};

var schema = exports.schema = {
  lim: _joi2.default.number().min(1).max(500),
  st: _joi2.default.number().min(1).max(2000),
  of: _joi2.default.string().regex((0, _helpers.createHyphonRegexp)(valid.of)),
  order: (_Joi$string = _joi2.default.string()).valid.apply(_Joi$string, _toConsumableArray(valid.order)).lowercase(),

  word: _joi2.default.string(),
  notword: _joi2.default.string(),
  title: _joi2.default.number().valid(1, 0),
  ex: _joi2.default.number().valid(1, 0),
  keyword: _joi2.default.number().valid(1, 0),
  wname: _joi2.default.number().valid(1, 0),

  biggenre: _joi2.default.string().regex((0, _helpers.createHyphonRegexp)(valid.biggenre)),
  notbiggenre: _joi2.default.string().regex((0, _helpers.createHyphonRegexp)(valid.biggenre)),

  genre: _joi2.default.string().regex((0, _helpers.createHyphonRegexp)(valid.genre)),
  notgenre: _joi2.default.string().regex((0, _helpers.createHyphonRegexp)(valid.genre)),

  userid: _joi2.default.string().regex((0, _helpers.createHyphonRegexp)('\\d+')).lowercase(),

  isr15: _joi2.default.number().valid(1, 0),
  isbl: _joi2.default.number().valid(1, 0),
  isgl: _joi2.default.number().valid(1, 0),
  iszankoku: _joi2.default.number().valid(1, 0),
  istensei: _joi2.default.number().valid(1, 0),
  istenni: _joi2.default.number().valid(1, 0),
  istt: _joi2.default.number().valid(1, 0),

  notr15: _joi2.default.number().valid(1, 0),
  notbl: _joi2.default.number().valid(1, 0),
  notgl: _joi2.default.number().valid(1, 0),
  notzankoku: _joi2.default.number().valid(1, 0),
  nottensei: _joi2.default.number().valid(1, 0),
  nottenni: _joi2.default.number().valid(1, 0),
  nottt: _joi2.default.number().valid(1, 0),

  minlen: _joi2.default.number(),
  maxlen: _joi2.default.number(),
  length: _joi2.default.string().regex(_helpers.rangeRegexp),

  kaiwaritu: _joi2.default.string().regex(_helpers.rangeRegexp),
  sasie: _joi2.default.string().regex(_helpers.rangeRegexp),

  mintime: _joi2.default.number(),
  maxtime: _joi2.default.number(),
  time: _joi2.default.string().regex(_helpers.rangeRegexp),

  ncode: _joi2.default.string().regex((0, _helpers.createHyphonRegexp)('n[\\d\\w]+')),

  type: (_Joi$string2 = _joi2.default.string()).valid.apply(_Joi$string2, _toConsumableArray(valid.type)).lowercase(),
  buntai: _joi2.default.string().regex((0, _helpers.createHyphonRegexp)(valid.buntai)),

  stop: _joi2.default.number().valid(1, 2, 0),
  ispickup: _joi2.default.number().valid(1, 0),

  lastup: _joi2.default.string().regex(new RegExp('^(' + valid.lastup.join('|') + ')$'))
};

exports.default = {
  url: _constant.protocol + '//api.syosetu.com/novelapi/api/',
  schema: _joi2.default.object(schema)
};


// WEBPACK FOOTER //
// ./src/api/novelapi.js